$shm_ba_filter_panel $mol_page
	has_source false
	state null
	data null
	period? *
		from \0001-01-01
		to \2999-12-31
	period_all *
		from \0001-01-01
		to \2999-12-31
	process_monitor_opened? false
	title \Фильтры
	title_content /
		<= Filters_head $mol_view
			sub <= filters_head_rows /
		<= Filter_summary $mol_view
			sub <= filter_summary_content /
	Filters_title $mol_view
		sub /
			\Фильтры
	Summary_expand $mol_check_expand
		checked? <=> summary_expanded? true
		expandable true
	Process_monitor_toggle $mol_check_icon
		hint \Process monitor
		Icon <= Process_monitor_toggle_icon $mol_icon_clock_fast
		checked? <=> process_monitor_opened? false
	Filter_reset $mol_button_minor
		title \Сбросить
		click? <=> filter_reset? null
	body /
		<= Filters $mol_view
			sub <= filters_rows /
	Empty $mol_view
		sub /
			\Выберите CSV-файл Brand Analytics
	Period_section $shm_ba_filter_section
		title_content /
			<= Period_icon $mol_icon_calendar
		Expand null
		tools /
		content /
			<= Period_filter $shm_ba_date
				period? <=> period?
				period_all <= period_all
	Search_section $shm_ba_filter_section
		title \Поиск
		Expand null
		tools /
			<= Search_index_status $mol_view
				sub /
					<= search_index_status \
				style *
					^
					color <= search_index_status_color \
		content /
			<= Search_row $mol_view
				sub /
					<= Search_filter $mol_search
						hint \Название или текст поста
						query? <=> search_query_draft? \
						submit? <=> search_submit? null
						clear? <=> search_clear? null
					<= Search_submit $mol_button_minor
						hint \Найти
						click? <=> search_submit? null
						sub /
							<= Search_submit_icon $mol_icon_magnify
	Tags_section $shm_ba_filter_section
		title \Теги
		table <= tags null
		filter? <=> tags_filter? *
	Message_types_section $shm_ba_filter_section
		title \Тип сообщения
		table <= message_types null
		filter? <=> message_types_filter? *
	Source_types_section $shm_ba_filter_section
		title \Тип источника
		table <= source_types null
		filter? <=> source_types_filter? *
	Sources_section $shm_ba_filter_section
		title \Источники
		table <= sources null
		filter? <=> sources_filter? *
	Authors_section $shm_ba_filter_section
		title \Авторы
		table <= authors null
		filter? <=> authors_filter? *
	Filter_summary_label* $mol_view
		sub /
			<= filter_summary_label* \
	Filter_summary_more $mol_button_minor
		title <= filter_summary_more_title \Еще
		click? <=> filter_summary_more? null
